/* ARG HEALTHCARE — blog page: rail toggle, result header, read-more links */
(function () {
  "use strict";
  var d = document, B = d.body;
  function $(s, r) { return (r || d).querySelector(s); }
  function $$(s, r) { return [].slice.call((r || d).querySelectorAll(s)); }

  /* ---- "Read more" link on every card ---- */
  function readMore() {
    $$(".bee-main-blog .bee-article-item").forEach(function (card) {
      if ($(".cxb-more", card)) return;
      var link = card.querySelector(".bee-article-title a");
      var info = $(".bee-article-info", card);
      if (!link || !info) return;

      var a = d.createElement("a");
      a.className = "cxb-more";
      a.href = link.getAttribute("href");
      a.innerHTML = '<span>Read article</span><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
      info.appendChild(a);
    });
  }

  /* ---- header showing what's being viewed ---- */
  function header() {
    var main = $(".bee-main-blog .bee-main-area");
    if (!main || $(".cxb-crumb", main)) return;

    var rail = $(".cxb-rail");
    if (!rail) return;
    var active = $(".cxb-cats li.is-on", rail);
    var count = $$(".bee-main-blog .bee-article-item").length;
    if (!count) return;

    var label = "All articles";
    if (active) {
      var s = active.querySelector("a > span");
      if (s) label = s.textContent.trim();
    }

    var wrap = d.createElement("div");
    wrap.className = "cxb-crumb";
    wrap.innerHTML =
      '<h2 class="cxb-crumb__t">' + label + "</h2>" +
      '<span class="cxb-crumb__n">' + count + (count === 1 ? " article" : " articles") + "</span>";

    // offer a way back when a category is open
    var isFiltered = active && !/^all/i.test(label);
    if (isFiltered) {
      var blogUrl = $(".cxb-cats li:first-child a");
      if (blogUrl) {
        var clear = d.createElement("a");
        clear.className = "cxb-crumb__clear";
        clear.href = blogUrl.getAttribute("href");
        clear.textContent = "View all";
        wrap.appendChild(clear);
      }
    }

    var list = $(".bee-blog-list", main);
    if (list) main.insertBefore(wrap, list);
    else main.insertBefore(wrap, main.firstChild);
  }

  function init() { readMore(); header(); }

  d.addEventListener("click", function (e) {
    if (!e.target.closest) return;
    if (e.target.closest("[data-cxb-open]")) { B.classList.add("cxb-open"); return; }
    if (e.target.closest("[data-cxb-close]")) { B.classList.remove("cxb-open"); }
  });
  d.addEventListener("keydown", function (e) {
    if (e.key === "Escape") B.classList.remove("cxb-open");
  });

  if (d.readyState === "loading") d.addEventListener("DOMContentLoaded", init);
  else init();

  // articles are swapped in on load-more / pagination
  var main = $(".bee-main-blog .bee-main-area");
  if (main && window.MutationObserver) {
    new MutationObserver(function () { setTimeout(readMore, 40); })
      .observe(main, { childList: true, subtree: true });
  }
})();